/*
 * Public API Surface of theme-lib
 */

export * from './lib/theme.service';

